
import EmployeePayRoll from "../../employeePayRoll/employeePayRol";

const EmpPayRollReport=()=>{
    return (
        <EmployeePayRoll />
    )
}
export default EmpPayRollReport;